import { Color, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'

import { PopoverBannerPosition } from '../types/popoverBannerPosition'

const arrowPositionOptions = {
  offset: `-${Spacing.S6}`,
  border: `1px solid ${Color.Black}`,
  centeredX: `left: 50%; transform: translateX(-50%) rotate(45deg);`,
  centeredY: `top: 50%; transform: translateY(-50%) rotate(45deg);`,
}

type ArrowPositionStyles = ReturnType<typeof css>

export const getArrowPositionVariants: Record<PopoverBannerPosition, ArrowPositionStyles> = {
  top: css`
    bottom: ${arrowPositionOptions.offset};
    ${arrowPositionOptions.centeredX}
    border-right: ${arrowPositionOptions.border};
    border-bottom: ${arrowPositionOptions.border};
  `,
  bottom: css`
    top: ${arrowPositionOptions.offset};
    ${arrowPositionOptions.centeredX}
    border-left: ${arrowPositionOptions.border};
    border-top: ${arrowPositionOptions.border};
  `,
  left: css`
    right: ${arrowPositionOptions.offset};
    ${arrowPositionOptions.centeredY}
    border-right: ${arrowPositionOptions.border};
    border-top: ${arrowPositionOptions.border};
  `,
  right: css`
    left: ${arrowPositionOptions.offset};
    ${arrowPositionOptions.centeredY}
    border-left: ${arrowPositionOptions.border};
    border-bottom: ${arrowPositionOptions.border};
  `,
}
